import { ListView } from '@progress/kendo-react-listview';
import MeainWarnItem from './meainWarnItem';
import { useState, useEffect } from 'react';
import {getMessage} from '../../../com/messageUtil';

import { getOperWarnMeainList } from '../../../service/monitor/operationService'

const OperationStatError = ({state}) => {

  return (
    <div className="uk-width-medium-1-3" >
      <div className="md-card">
        <div className="md-card-content" className="operationPage1-3">
          <div className="md-card-toolbar">
            <h3 className="md-card-toolbar-heading-text">
              장애설비
            </h3>
            <div className="md-card-toolbar-actions">
              (1시간 기준)
            </div>
          </div>
          <div className="scroolY">
          { state.meainErrorList.length !== 0 ? 
              (<ListView 
                data = {state.meainErrorList}
                item={MeainWarnItem}
              />): <span className = "scroolYOper"><b>데이터가 존재하지 않습니다.</b></span>
            }
          </div>
        </div>
      </div>
    </div>
  )
}

export default OperationStatError;